package com.shadowings.gero.data.lessons.chapter1
import com.shadowings.gero.data.lessons.buildHieroQuizContent
import com.shadowings.gero.data.lessons.chapter5.toHieroList
import com.shadowings.gero.data.lessons.toHieroExplanation


import com.shadowings.gero.data.repository.Hiero
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.presentation.model.Word
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_iniziamo_a_studiare_i_primi_simboli
import gero.composeapp.generated.resources.exp_title_introduzione
import gero.composeapp.generated.resources.swipe_up

fun getUni1Content(
    hiero: List<Hiero>,
    words: List<Word>,
    languageCode: String
): List<IExplanation> {

    val signs = famousNames.toHieroList(words).take(8)

    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_introduzione,
            content = Res.string.exp_content_iniziamo_a_studiare_i_primi_simboli,
            face = Faces.Happy,
            image = Res.drawable.swipe_up,
            imageSize = 0.35f,
        ),
    ) + signs.toHieroExplanation(hiero, languageCode)
}

fun getUni_1QuizContent(
    hiero: List<Hiero>,
    words: List<Word>,
    languageCode: String
): List<IQuizContent> {
    return buildHieroQuizContent(
        hiero = hiero,
        hieroContent = getUni1Content(hiero, words, languageCode),
        languageCode = languageCode,
        previousHieroContent = listOf()
    )
}
